import { useAppConfig } from '#app';

interface ApiOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: any;
  headers?: Record<string, string>;
  query?: Record<string, any>;
}

interface ApiResponse<T> {
  data?: T;
  error?: any; // Use any or a specific error object type
  success: boolean;
  elapsed_time?: string;
  response?: any;
}

function trimCharacter(str: string, char: string | RegExp): string {
  if (typeof char === 'string') {
    const regex = new RegExp(`^${char}+|${char}+$`, 'g');
    return str.replace(regex, '');
  } else {
    const regex = new RegExp(`^${char.source}+|${char.source}+$`, 'g');
    return str.replace(regex, '');
  }
}

export async function useBaseApi<T>(endpoint: string, options: ApiOptions = {}): Promise<ApiResponse<T>> {
  const appConfig = useAppConfig();
  const accountStore = useAccounts()
  try {
    options.method ??= "GET";
    const defaultHeaders = {
      'Content-Type': 'application/json',
    };

    // Merge default headers with provided headers
    const mergedHeaders = {
      ...defaultHeaders,
      ...options.headers,
    };
    const mergedBody = options.method?.toLocaleLowerCase() !== 'get' ? {
      at: accountStore.token,
      ...options.body,
    } : undefined;

    const mergedQuery = options.method?.toLocaleLowerCase() === 'get' ? {
      at: accountStore.token,
      ...options.query,
    } : undefined;

    const response: ApiResponse<T> = await $fetch<ApiResponse<T>>(
      `${trimCharacter(appConfig.base?.apiBaseUrl, '/')}/${trimCharacter(endpoint, '/')}`,
      {
        method: options.method,
        body: mergedBody,
        headers: mergedHeaders,
        query: mergedQuery,
      }
    );
    return {
      data: response.data,
      elapsed_time: response.elapsed_time,
      success: response.success,
      error: response.error,
      response: response,
    };
  } catch (error: any) { // Use any or a specific error object type
    return {
      error: error,
      success: false,
    };
  }
}